import { StepStatus, Wizard, WizardStatus } from '../../../../../../domain/wizard/wizard'
import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export const getIchraProductClassDesignWizard = async (productClassId: string): Promise<Wizard> => {
  return adminHttpClient.get(`/AdminDashboard/ichra/ClassDesignWizard/${productClassId}`)
}

export const mockGetIchraProductClassDesignWizard = async (productClassId: string): Promise<Wizard> => {
  return {
    id: '19',
    steps: [
      {
        id: 'ichra-class-design-select-eligible-expenses',
        status: StepStatus.Active,
        name: 'Select Eligible Expenses',
        children: [],
        priority: 1,
      },
      {
        id: 'ichra-class-design-set-allowance',
        status: StepStatus.Disabled,
        name: 'Select Allowances',
        children: [],
        priority: 2,
      },
      {
        id: 'ichra-class-design-set-waiting-period',
        status: StepStatus.Disabled,
        name: 'Select Waiting Period',
        children: [],
        priority: 2,
      },
    ],
    wizardId: 19,
    status: WizardStatus.InProgress,
    title: 'ICHRA Class Design Wizard',
  }
}
